import call from "./call";
import {
  QueueLoadData,
  DbConnectionsData,
  AuthLogsData,
  ErrorLogsData,
  AgentLogsData,
  HardwareStatusData,
  ServiceStatusData,
} from "../Models/monitoring";

export type {
  QueueLoadTaskItem,
  QueueLoadWorker,
  QueueLoadData,
  DbConnectionEntry,
  DbConnectionsData,
  AuthLogsData,
  ErrorLogsData,
  AgentLogsData,
  HardwareStatusData,
  HardwareCpu,
  HardwareCpuCore,
  HardwareMemory,
  HardwareDisk,
  HardwareLoad,
  HardwareNetwork,
  ServiceStatusData,
  ServiceEntry,
  ServiceMemory,
  ServiceNetwork,
} from "../Models/monitoring";

export const getQueueLoad = async (): Promise<QueueLoadData> => {
  const { data } = await call.get("/v1/monitoring/queue_load", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data.data;
};

/* ── Database Connections ── */

export const getDbConnections = async (): Promise<DbConnectionsData> => {
  const { data } = await call.get("/v1/monitoring/current_db_connections", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data;
};

/* ── Auth Logs ── */

export const getAuthLogs = async (): Promise<AuthLogsData> => {
  const { data } = await call.get("/v1/monitoring/auth_logs", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data.data;
};

/* ── Error Logs ── */

export const getErrorLogs = async (): Promise<ErrorLogsData> => {
  const { data } = await call.get("/v1/monitoring/error_logs", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data.data;
};

/* ── Agent Runtime Logs ── */

export const getAgentLogs = async (): Promise<AgentLogsData> => {
  const { data } = await call.get("/v1/monitoring/agent_logs", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data.data;
};

/* ── Hardware Status ── */

export const getHardwareStatus = async (): Promise<HardwareStatusData> => {
  const { data } = await call.get("/v1/monitoring/hardware_status", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data.data;
};

/* ── Service (per-container) Status ── */

export const getServiceStatus = async (): Promise<ServiceStatusData> => {
  const { data } = await call.get("/v1/monitoring/service_status", {
    snack: {
      error: "monitoringFetchError",
    },
  });

  return data.data;
};
